import baseRoute from '../baseRoute';

export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/companiesRevenueTable/totals${`?date=${string}` | ''}`;

export const ROUTE: RouteDefinition = `${baseRoute}/companiesRevenueTable/totals`;

/**
 *
 * @param date YYYY-MM-DD
 */
export const URL = (date: string): RouteDefinition => `${baseRoute}/companiesRevenueTable/totals?date=${date}`;
